// import { useState } from 'react';
import { FieldArray, FormikErrors } from 'formik';
import cx from 'classnames';
import { Checkbox, Icon, IconButton, Toggle, Text, TextInput } from '@intellecteu/common-ui';
import { Labels } from 'app/constants';
import { EnvVar } from 'data';
import { ui } from 'ui/styles';
import { Field } from '../ui/form/field';

import s from './styles.module.scss';

type Props = {
  envVars?: EnvVar[];
  envVarsDelete?: EnvVar[];
  isLoading?: boolean;
  errors: string | string[] | FormikErrors<EnvVar>[] | undefined;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  title?: string;
  fieldName?: string;
  fieldNameToDelete?: string;
  className?: string;
};

const initVariables = [
  {
    name: '',
    value: '',
    valueFrom: null,
  },
];

export const EnvVariables = ({
  envVars,
  envVarsDelete,
  isLoading,
  setFieldValue,
  errors,
  // title,
  fieldName,
  fieldNameToDelete,
  className,
}: Props) => {
  const envVarsFieldName = fieldName ?? 'envVars';
  const envVarsToDeleteFieldName = fieldNameToDelete ?? 'envVarsDelete';
  // const [showEnvVars, setShowEnvVars] = useState(!!envVars?.length || false);

  // const toggleShowEnvVars = () => {
  //   setShowEnvVars((prev) => {
  //     if (prev) {
  //       setFieldValue(envVarsFieldName, []);
  //     } else {
  //       setFieldValue(envVarsFieldName, initVariables);
  //     }
  //
  //     return !prev;
  //   });
  // };

  const addVariable = (push: (v: EnvVar) => void) => () => {
    push(initVariables[0]);
  };

  const removeVariable = (remove: (idx: number) => void, index: number) => () => {
    const removedVar = (envVars && envVars[index]) ?? undefined;
    if (removedVar) {
      const updated = [...(envVarsDelete ?? []), removedVar];

      // deduplicate by name
      const unique = updated.filter((item, idx, self) => idx === self.findIndex((t) => t.name === item.name));

      setFieldValue(envVarsToDeleteFieldName, unique);
    }
    remove(index);
  };

  const handleOnChange = (index: number) => {
    if (envVars && !envVars[index].valueFrom) {
      setFieldValue(`${envVarsFieldName}[${index}].value`, '');
      setFieldValue(`${envVarsFieldName}[${index}].valueFrom.secretKeyRef`, {
        key: '',
        name: '',
        optional: false,
      });
    } else {
      setFieldValue(`${envVarsFieldName}[${index}].valueFrom`, null);
    }
  };

  return (
    <div className={cx(ui.formSidebarContent, className)}>
      <div className={ui.section}>
        {/* <div className={s.envsHeader}> */}
        {/*   <Toggle.Small */}
        {/*     className={s.envsCheckbox} */}
        {/*     horizontal */}
        {/*     id={`${envVarsFieldName}-enable`} */}
        {/*     checked={showEnvVars} */}
        {/*     onChange={toggleShowEnvVars} */}
        {/*   /> */}
        {/*   <InfoItem label={title ?? Labels.ENV_VARS} labelSize="s" labelColor="dark" labelWeight="bold" /> */}
        {/* </div> */}

        {/* {showEnvVars && ( */}
        <FieldArray
          name={envVarsFieldName}
          render={({ push, remove }) => (
            <div className={ui.fieldGroup}>
              {envVars?.map((env, index) => (
                <div key={`${envVarsFieldName}-variable-${index}`}>
                  <div className={s.envsItemHeader}>
                    <Text size="s" weight="bold">
                      {`Variable ${index + 1}`}
                    </Text>
                    {/* {index >= initVariables.length && ( */}
                    <IconButton
                      iconSize="s"
                      onClick={removeVariable(remove, index)}
                      iconName={Icon.icons.remove}
                      tooltipText="Remove"
                      tooltipPosition="right"
                      tooltipClassName={s.envsRemoveTooltip}
                    />
                    {/* )} */}
                  </div>

                  <div className={s.envsItem}>
                    <Field
                      component={TextInput}
                      id={`${envVarsFieldName}[${index}].name`}
                      name={`${envVarsFieldName}[${index}].name`}
                      label="Name*"
                      data-1p-ignore
                      autoFocus
                    />

                    <Toggle.Small
                      id={`${envVarsFieldName}[${index}]_set_secret_as_source`}
                      label="Secret as a source"
                      onChange={() => handleOnChange(index)}
                      checked={!!envVars[index]?.valueFrom}
                      className={s.envsItemSecret}
                      horizontal
                    />
                  </div>

                  <div
                    className={cx(
                      s.envsItemSource,
                      envVars[index].valueFrom ? s.envsItemSourceValueFrom : s.envsItemSourceValue,
                    )}
                  >
                    {envVars[index].valueFrom ? (
                      <div className={ui.fieldGroup}>
                        <div className={s.envsItem}>
                          <Field
                            component={TextInput}
                            id={`${envVarsFieldName}[${index}].valueFrom.secretKeyRef.key`}
                            name={`${envVarsFieldName}[${index}].valueFrom.secretKeyRef.key`}
                            label={`${Labels.SECRET_KEY}*`}
                          />
                          <Field
                            component={TextInput}
                            id={`${envVarsFieldName}[${index}].valueFrom.secretKeyRef.name`}
                            name={`${envVarsFieldName}[${index}].valueFrom.secretKeyRef.name`}
                            label={`${Labels.SECRET_NAME}*`}
                          />
                        </div>
                        <Field
                          containerClassName={s.checkbox}
                          component={Checkbox}
                          id={`${envVarsFieldName}[${index}].valueFrom.secretKeyRef.optional`}
                          name={`${envVarsFieldName}[${index}].valueFrom.secretKeyRef.optional`}
                          label="Optional"
                          checked={envVars[index].valueFrom?.secretKeyRef?.optional}
                        />
                      </div>
                    ) : (
                      <Field
                        component={TextInput}
                        id={`${envVarsFieldName}[${index}].value`}
                        name={`${envVarsFieldName}[${index}].value`}
                        label="Value*"
                      />
                    )}
                  </div>

                  <div className={ui.separator} />
                </div>
              ))}

              <div className={s.envsAdd}>
                <IconButton
                  className={ui.fieldGroupIcon}
                  onClick={addVariable(push)}
                  tooltipText="Add variable"
                  iconName={Icon.icons.add}
                  iconClassName={ui.fieldGroupIcon}
                  tooltipPosition="left"
                  tooltipClassName={s.envsAddTooltip}
                  id="variable_add"
                  disabled={isLoading}
                />
              </div>

              <div className={cx(s.formArrayControlError, !errors && s.formArrayControlErrorHidden)}>
                {typeof errors === 'string' && errors}
              </div>
            </div>
          )}
        />
        {/* )} */}
      </div>
    </div>
  );
};
